export default __webpack_public_path__ + "static/media/super-core-logo.9c61ec4e.svg";